import React from 'react'
import { Button, Input } from 'src/components'
import { useStyles } from './styles'

interface FilterInputProps {
  filterValue: string
  onFilterChange: (value: string) => void
  onApplyFilters: () => void
  onClearFilters: () => void
  placeholder?: string // Nova propriedade para o placeholder
}

export const FilterInput: React.FC<FilterInputProps> = ({
  filterValue,
  onFilterChange,
  onApplyFilters,
  onClearFilters,
  placeholder = 'Filtrar por valor' // Valor padrão
}) => {
  const style = useStyles()

  return (
    <div className={style.filterContainer}>
      <Input
        label='Filtrar'
        id='filterGeneral'
        type='text'
        placeholder={placeholder}
        value={filterValue}
        onPressEnter={onApplyFilters}
        onChange={(value: string) => onFilterChange(value)}
      />
      <div className='containerButtons'>
        <Button
          onClick={onApplyFilters}
          disabled={!filterValue}
          className={style.buttonWrapper}
        >
          Filtrar
        </Button>
        <Button
          className={`${style.buttonOutlined} ${style.buttonWrapper}`}
          onClick={onClearFilters}
          disabled={!filterValue}
          outlined
        >
          Limpar
        </Button>
      </div>
    </div>
  )
}
